import Model, {ModelErrors} from "./Model";

export interface CartItemData {
  id?: number;
  order_id?: number;
  value: number;
  quantity: number;
  sku: string;
  status: string;
  refund_id: string;
}

export const CART_ITEM_DONATION = 'DONATION';

export default class CartItemModel extends Model<CartItemData> {
  defaults(): CartItemData {
    return {
      value: 0.00,
      quantity: 1,
      sku: '',
      status: '',
      refund_id: '',
    };
  }

  isDonation(): boolean {
    return this.data.sku === CART_ITEM_DONATION;
  }
}

export function create(data?: CartItemData, errors?: ModelErrors): CartItemModel {
  return new CartItemModel(data, errors);
}
